/**
 * TODO: This should be refactored when feature is fully implemented.
 * This is just temporary solution.
 */
export const maintenanceNotice = {
  endDate: new Date(2026, 8, 13, 23, 59, 59),
  title: 'Plato Connect will undergo maintenance 9/11/26 through 9/13/26.',
  message: 'Please do not use the system even if it appears available for use.',
} as const;

export const isMaintenanceNoticeVisible = () => {
  return new Date() < maintenanceNotice.endDate;
};
